import { doc, getDoc, serverTimestamp, setDoc } from "firebase/firestore";

import { db } from "../firebase/config";

// Idempotent. Called on every auth state change, so it must never clobber an
// existing profile — it writes only when the document is genuinely absent.
export async function createUserProfile(user) {
  const userRef = doc(db, "users", user.uid);

  const snapshot = await getDoc(userRef);

  if (snapshot.exists()) {
    return;
  }

  await setDoc(userRef, {
    displayName: user.email.split("@")[0],
    email: user.email,

    avatarId: null,
    profileCompleted: false,

    activeGroupId: null,
    joinedGroups: [],

    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
}

// Merged rather than updated throughout: on a brand-new account this can race
// with createUserProfile(), and updateDoc() would throw "No document to update".
export async function setActiveGroup(userId, groupId) {
  await setDoc(
    doc(db, "users", userId),
    { activeGroupId: groupId, updatedAt: serverTimestamp() },
    { merge: true },
  );
}

// Profile setup and later edits both land here. Completing it once flips
// profileCompleted, which is what the gate in useProfile keys on.
export async function updateUserProfile(userId, { displayName, avatarId }) {
  await setDoc(
    doc(db, "users", userId),
    {
      displayName,
      avatarId,
      profileCompleted: true,
      updatedAt: serverTimestamp(),
    },
    { merge: true },
  );
}

export async function getUserProfile(userId) {
  const snapshot = await getDoc(doc(db, "users", userId));

  if (!snapshot.exists()) return null;

  return {
    id: snapshot.id,
    ...snapshot.data(),
  };
}
